import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, EnumDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { DataValidator } from '@stamhoofd/utility';
/**
 * Possibles status returned from uitpas api
 * https://docs.publiq.be/docs/uitpas/uitpas-api/reference/operations/get-a-pass
 */
export var UitpasSocialTariffStatus;
(function (UitpasSocialTariffStatus) {
    // if the status has not been checked yet
    UitpasSocialTariffStatus["Unknown"] = "Unknown";
    // status returned from uitpas api
    UitpasSocialTariffStatus["Active"] = "Active";
    UitpasSocialTariffStatus["Expired"] = "Expired";
    UitpasSocialTariffStatus["None"] = "None";
})(UitpasSocialTariffStatus || (UitpasSocialTariffStatus = {}));
/**
* Data returned from uitpas api.
* https://docs.publiq.be/docs/uitpas/uitpas-api/reference/operations/get-a-pass
*/
export class UitpasSocialTariff extends AutoEncoder {
    status;
    /**
     * Exact expiration date of the passholder's entitlement to a social tariff. This property must not be used to determine the social tariff status, because status can be ACTIVE while the endDate is in the past during a 'grace period'. This property is not available when status is NONE.
     */
    endDate = null;
    updatedAt = new Date();
    /**
     * @returns true if updated more than 1 week ago
     */
    isUpdateOutdated() {
        const now = new Date();
        // should check if updated more than 1 week ago
        const weekInMs = 604800000;
        return now.getTime() - this.updatedAt.getTime() > weekInMs;
    }
    /**
     * Whether a social tariff update is required for saving or registering the member.
     * @param requiresFinancialSupport
     * @returns
     */
    shouldUpdateForRegsitration(requiresFinancialSupport) {
        // does not matter if financial support is required
        if (requiresFinancialSupport?.value === true) {
            return false;
        }
        if (this.status === UitpasSocialTariffStatus.Unknown) {
            return true;
        }
        return this.isUpdateOutdated();
    }
}
__decorate([
    field({ decoder: new EnumDecoder(UitpasSocialTariffStatus) })
], UitpasSocialTariff.prototype, "status", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], UitpasSocialTariff.prototype, "endDate", void 0);
__decorate([
    field({ decoder: DateDecoder })
], UitpasSocialTariff.prototype, "updatedAt", void 0);
export class UitpasNumberDetails extends AutoEncoder {
    uitpasNumber;
    socialTariff = UitpasSocialTariff.create({
        status: UitpasSocialTariffStatus.Unknown,
    });
    get isActive() {
        if (this.socialTariff.status === UitpasSocialTariffStatus.Active) {
            return true;
        }
        // Fallback to legacy check if unknown
        if (this.socialTariff.status === UitpasSocialTariffStatus.Unknown && this.uitpasNumber) {
            if (DataValidator.isUitpasNumberKansenTarief(this.uitpasNumber)) {
                return true;
            }
        }
        return false;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], UitpasNumberDetails.prototype, "uitpasNumber", void 0);
__decorate([
    field({ decoder: UitpasSocialTariff })
], UitpasNumberDetails.prototype, "socialTariff", void 0);
//# sourceMappingURL=UitpasNumberDetails.js.map